var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LLTimestamp',{staticClass:"ForumResponseTimestamp",attrs:{"timestamp":_vm.response.createdAt},scopedSlots:_vm._u([{key:"default",fn:function(data){return [_vm._v(" "+_vm._s(_vm.$tc('timestamp_replied', data.time))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }